import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Appsimpact() {
  return (
    <section className="apps_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>We've Helped Thousands Of Apps Reach Over 480M Downloads...</h2>
            <strong>Will Your App Be Next?</strong>
            <p>
              Quality, reliability, and security are dispatched seamlessly
              through our mobile, web & enterprise solutions. Experience it
              first-hand.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto text-center"
          >
            <div className="apps_impact">
              <StaticImage
                src="../../../images/case-studies/impact/apps.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={783}
                height={595}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Appsimpact;
